export const TOD_PROFILES_IMAGES = "TOD_PROFILES_IMAGES"
export const MOBILE = "MOBILE"
export const VERIFICATION = "VERIFICATION"
export const VOICE = "VOICE"